import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52ef10d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exercise__hould_out" }
const _hoisted_2 = {
  key: 0,
  class: "last_round_info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_alert = _resolveComponent("app-alert")!
  const _component_app_exercise_header = _resolveComponent("app-exercise-header")!
  const _component_app_start_tip = _resolveComponent("app-start-tip")!
  const _component_app_counter = _resolveComponent("app-counter")!
  const _component_app_exercise_action_btn = _resolveComponent("app-exercise-action-btn")!
  const _component_app_exercise_footer = _resolveComponent("app-exercise-footer")!
  const _component_app_leave_exercise_confirm = _resolveComponent("app-leave-exercise-confirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_app_exercise_header, null, {
        additional: _withCtx(() => [
          (_ctx.showAreYouThere)
            ? (_openBlock(), _createBlock(_component_app_alert, {
                key: 0,
                mode: "warning",
                dismiss: _ctx.dismissAlert
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("ex.hold.are_you_still_there")), 1)
                ]),
                _: 1
              }, 8, ["dismiss"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("ex.hold.title")) + " ", 1)
        ]),
        _: 1
      }),
      (_ctx.showStartTip)
        ? (_openBlock(), _createBlock(_component_app_start_tip, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("ex.hold.start_tip")), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_app_counter, { number: _ctx.counter }, null, 8, ["number"]),
            _createElementVNode("section", null, [
              _createVNode(_component_app_exercise_action_btn, {
                onClick: _ctx.nextScreen,
                "data-test": "breath-hold-next-screen-action-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("ex.hold.skip_to_next")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode(_component_app_exercise_footer, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("ex.hold.footer_tip")) + " ", 1),
                (_ctx.isLastRound)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_ctx.$t("ex.hold.last_round_tip")), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 64))
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_app_leave_exercise_confirm, {
          key: 0,
          cancelHandler: _ctx.preventCancelExercise,
          confirmHandler: _ctx.confirmCancelExercise
        }, null, 8, ["cancelHandler", "confirmHandler"]))
      : _createCommentVNode("", true)
  ], 64))
}